/**
 * Maps legacy or alternate `bp_business_type` strings from the backend to the
 * canonical labels in `BUSINESS_TYPES` (CONSTANTS.ts).
 */
export const BUSINESS_TYPE_ALIASES: Record<string, string> = {
  Bakery: 'Bakery & Pastry',
  'Beauty Shop': 'Beauty & Cosmetics',
  Boutique: 'Boutique & Apparel',
  Electronics: 'General Electronics',

  Bookshop: 'BookShop',
  'Wines & Spirits': 'Wines and Spirits',
  Chemist: 'Pharmacy',
  Cafe: 'Coffee Shop',
  Hardware: 'Hardware Store',
  'Grocery / Mini Mart': 'Mini Mart',
  'Auto Parts & Garage': 'AutoSpares',
  'Electronics & Mobile': 'General Electronics',
  'Furniture & Upholstery': 'Furniture and Fittings',
  'Salon & Spa': 'Beauty & Cosmetics',
  Bar: 'Bar & Restaurant',
  'Hotel & Restaurant': 'Hotel',
};

export function normalizeBusinessType(bt?: string | null): string {
  const key = String(bt ?? '').trim();
  return BUSINESS_TYPE_ALIASES[key] ?? key;
}
